<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >

    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-container v-else fluid>
    <v-row cols="12" class="v-card v-sheet theme--light mx-auto fill-height" :style="`min-height: calc(100vh - 24px - ${!$store.state.auth.default_user ? '0px' : '24px'})`">
      <v-col :cols="leaderboard ? 8 : 12" class="transition-ease-in-out">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :loading="loading"
          :items="items"
          :server-items-length="totalItems"
          :page="page"
          :items-per-page.sync="paginationOptions.perPage"
          :footer-props="{ itemsPerPageOptions: [ 30, 60, 90, 120 ] }"
          :sort-by.sync="paginationOptions.sortBy"
          :sort-desc.sync="paginationOptions.sortDesc"
          fixed-header
          single-select
          show-select
          item-key="tournament_id"
          @item-selected="selectTournament"
          @update:page="loadTournamentList"
          class="th-nowrap"
          :height="`calc(100vh - 200px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        >
          <template v-slot:item.amount="{ item }">
            {{ item.amount + (item.amount_prefix === 'P' ? '%' : '') }}
          </template>
          <template v-slot:item.affiliate="{ item }">
            {{ item.rules.affiliate }}
          </template>
          <template v-slot:item.date_start="{ item }">
            <span class="nowrap">{{ item.date_start }}</span>
          </template>
          <template v-slot:item.date_end="{ item }">
            <span class="nowrap">{{ item.date_end }}</span>
          </template>
          <template v-slot:top>
            <v-row class="mx-auto">
              <select-project
                v-model="entity_id"
                :style="{'max-width': leaderboard ? 'calc(35% - 70px)' : '100%'}"
                class="mr-5"
              />
              <v-select
                v-model="statuses"
                :items="statusesList"
                label="Statuses"
                :style="{'max-width': leaderboard ? 'calc(65% - 70px)' : '100%'}"
                multiple
                class="mr-5"
              >

                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="toggleAllStatuses"
                  >
                    <v-list-item-action>
                      <v-icon :color="statuses.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Select All</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>

                <template v-slot:selection="{ item, index }">
                  <v-chip small v-if="index < chipCount">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span
                    v-if="index === chipCount && statuses.length > chipCount"
                    class="grey--text caption"
                  >(+{{ statuses.length - chipCount }} others)</span>
                </template>
              </v-select>
              <v-btn
                @click="loadTournamentList"
                color="info"
                class="mt-2"
                :disabled="loading"
                :loading="loading"
              >
                Search
              </v-btn>
            </v-row>
          </template>

        </v-data-table>
      </v-col>
      <v-col cols="4" :hidden="!leaderboard">
        <v-data-table
          v-if="leaderboard"
          :headers="headersLeaderboard"
          :items="leaderboard"
          :loading="loading"
          :disable-pagination="true"
          :height="`calc(100vh - 48px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
          fixed-header
          hide-default-footer
          class="th-nowrap"
        >
        </v-data-table>
      </v-col>
    </v-row>

  </v-container>
</template>
<style>
  .nowrap,
  .th-nowrap th {
    white-space: nowrap;
  }
</style>

<script>
  import { API } from '@/utils/api'
  import { map, cloneDeep, get } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    components: { SelectProject },

    data: () => ({
      leaderboard: false,
      validUpdateForm: false,
      loading: false,
      statuses: [
        'upcoming', 'running', 'finished', 'complete', 'expired', 'failed', 'canceled'
      ],
      statusesList: [
        'upcoming', 'running', 'finished', 'complete', 'expired', 'failed', 'canceled'
      ],
      selected: [],
      entity_id: null,
      headers: [
        { text: 'ID', value: 'tournament_id', sortable: true },
        { text: 'Alias', sortable: false, value: 'alias' },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Status', sortable: false, value: 'status' },
        { text: 'Start', value: 'start' },
        { text: 'End', value: 'end' },
        { text: 'Enabled', sortable: false, value: 'enabled' },
      ],
      headersLeaderboard: [
        { text: 'Place', value: 'place', sortable: true },
        // { text: 'ParticipantId', sortable: false, value: 'participant_id' },
        { text: 'Login', value: 'player.login', sortable: false },
        { text: 'Currency', sortable: false, value: 'player.currency' },
        { text: 'Rating', sortable: false, value: 'player.rating' },
        { text: 'Rounds', sortable: false, value: 'player.rounds' },
        { text: 'Total Rounds', sortable: false, value: 'player.total_rounds' },
      ],
      chipCount: 5,
      items: [],
      totalItems: 0,
      page: 1,
      paginationOptions: {
        perPage: 30,
        sortBy: 'start',
        sortDesc: true,
      }
    }),

    computed: {

      selectedAllStatuses () {
        return this.statuses.length === this.statusesList.length
      },
      selectedSomeStatuses () {
        return this.statuses.length > 0 && !this.selectedAllStatuses
      },
      icon () {
        if (this.selectedAllStatuses) return 'mdi-close-box'
        if (this.selectedSomeStatuses) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
    },

    mounted () {
      this.entity_id = this.$store.state.auth.entities[0].entity_id
    },

    watch: {
      entity_id (val) {
        this.entity_id = val
        this.totalItems = 0
        this.loadTournamentList()
      },
      paginationOptions: {
        handler() {
          this.loadTournamentList(this.page)
        },
        deep: true,
      }
    },

    methods: {

      loadTournamentList (page = 1) {
        this.leaderboard = false
        this.loading = true
        if (this.statuses.length == 0) {
          this.statuses = this.statusesList.slice()
        }
        return API.call('/$v/tournament/list.json', {
          ...this.paginationOptions,
          page,
          statuses: this.statuses,
        }, null, this.entity_id).then(resp => {
          this.items = resp.data.tournaments || []
          this.totalItems = resp.data.total
          this.page = resp.data.page
        }).finally(() => this.loading = false)
      },
      loadLeaderboard (tournament_id) {
        this.leaderboard = []
        this.loading = true
        return API.call('/$v/tournament/leaderboard.json', {
          tournament_id
        }, null, this.entity_id).then(resp => {
          this.leaderboard = resp.data
        }).finally(() => this.loading = false)
      },

      selectTournament (data) {
        if (!data.value) {
          this.leaderboard = false
          this.chipCount = 6
        } else {
          this.chipCount = 4
          return this.loadLeaderboard(data.item.tournament_id)
        }
      },

      toggleAllStatuses () {
        this.$nextTick(() => {
          if (this.selectedAllStatuses) {
            this.statuses = []
          } else {
            this.statuses = this.statusesList.slice()
          }
        })
      },

    }
  }
</script>
